/* Il corpo della richiesta «copertura dal sito TIM», uno per tutti.

   Nasce da un difetto vero (06/10/2026): la pagina desktop passava un oggetto, la PWA
   passava tre argomenti separati, e i due adattatori avevano firme diverse. Dal desktop
   l'agente riceveva «Comune e via obbligatori», perche' l'oggetto intero finiva nel campo
   comune. Una firma sola, in un posto solo, e il disallineamento non puo' tornare. */

export function corpoCoperturaTim(indirizzo) {
  const a = indirizzo || {};
  return {
    provincia: (a.provincia || '').trim(),
    comune: (a.comune || '').trim(),
    // `indirizzo` e' il nome che il campo ha nella scheda: per il backend e' `via`
    via: (a.via || a.indirizzo || '').trim(),
    civico: (a.civico || '').trim(),
  };
}

/* Vero solo se c'e' il minimo che il sito TIM richiede: senza comune e via la verifica
   non puo' partire, e dirlo qui evita una chiamata che tornerebbe 400. */
export function corpoValido(corpo) {
  return !!(corpo && corpo.comune && corpo.via);
}
